<textarea
    #textareaRef
    pTextarea
    ngDefaultControl
    class="w-full"
    [class.resize-y]="props?.persistSize"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [autofocus]="props?.autofocus"
    [placeholder]="props?.placeholder"
    [readonly]="props?.readonly || props?.disabled"
    [required]="props?.required"
    [rows]="props?.rows"
    [disabled]="props?.disabled"
    phx-mention
></textarea>
